import React, { useState } from "react";
import LoginComponent from "../../components/login";
import { useUserContext } from "../../contexts/user/userContext";
import * as S from "./styles";
import * as GS from "../../utils/globalStyles/background";
import { useNavigate } from "react-router-dom";
/* import ModalNotification from "../../components/modalNotification"; */
import { getAuthenticate, getMe } from "../../utils/services/modules/login";
import { toast } from "react-toastify";

const Login: React.FC = () => {
  /* const [showModal, setShowModal] = useState<boolean>(false); */
  const { dispatch: userDispatch } = useUserContext();
  const navigate = useNavigate();

  const [userName, setUserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const ensureMinimumLoadingTime = async (
    promise: Promise<any>,
    minTime: number,
  ) => {
    const start = Date.now();
    const result = await promise;
    const elapsed = Date.now() - start;
    const remainingTime = minTime - elapsed;
    if (remainingTime > 0) {
      await new Promise((resolve) => setTimeout(resolve, remainingTime));
    }
    return result;
  };

  const getInfo = async (token: string) => {
    try {
      const data = await getMe(token);
      localStorage.setItem("token", token);
      userDispatch({
        type: "SET_USER",
        payload: {
          name: data?.user.name,
          userName: data?.user.userName,
          coins: data?.user.coins,
          code: data?.user.code,
          avatar: data?.user.avatar,
          cellphone: data?.user.cellphone,
          isAdmin: data?.user.isAdmin,
          contacts: data?.user.contacts,
          token: token,
        },
      });
    } catch (error) {
      userDispatch({ type: "CLEAR_USER" });
      console.error("Erro ao buscar informações do usuário:", error);
    }
  };

  const handleLogin = async () => {
    if (!userName || !password) {
      return;
    }

    try {
      setLoading(true);
      await ensureMinimumLoadingTime(
        (async () => {
          const data = await getAuthenticate(userName, password);
          await getInfo(data.token); // usa o token retornado
        })(),
        3000,
      );

      navigate("/news");
    } catch (error: any) {
      console.error("Erro ao autenticar:", error?.response?.data?.error);
      /* setShowModal(true); */
      toast.error("Usuário e/ou Senha inválidos!", {
        position: "top-right",
        autoClose: 3000, // Fecha automaticamente após 3 segundos
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <GS.Background>
      {/* Envolvendo os elementos visuais no nosso novo Wrapper */}
      <S.ContentWrapper>
        <S.Image />
        <LoginComponent
          setUserName={setUserName}
          setPassword={setPassword}
          handleLogin={handleLogin}
        />
      </S.ContentWrapper>

      <GS.BackdropMui
        open={loading}
        style={{
          zIndex: 1300,
          color: "#fff",
        }}
      >
        <GS.CircularProgressMui color="inherit" size={80} />
      </GS.BackdropMui>
    </GS.Background>
  );
};

export default Login;
